(function($) {

    function sidebarOpen(){
        $('html').addClass('overflow_hidden');
        $(".nav").addClass("nav-bg");
        $(".nav__sidebar").addClass("nav__sidebar--opened");
        $(".nav__hamburger-icon").addClass("nav__hamburger-icon--opened");
        $(".nav__hamburger").addClass("nav__hamburger--opened");

        // Added: calculate sidebar position when opening

        setTimeout(() => {
            $('body').addClass('nav-overlay')
        }, 1)
    }

    function sidebarClose(){

        $(".nav__sidebar").removeClass("nav__sidebar--opened");
        $('body').removeClass('nav-overlay');
        $(".nav").removeClass("nav-bg");
        $(".nav__hamburger-icon").removeClass("nav__hamburger-icon--opened");
        $(".nav__hamburger").removeClass("nav__hamburger--opened");
        $('html').removeClass('overflow_hidden');
    }

    // Close sidebar on body overlay click
    $(document).on("click", "body.nav-overlay .body-content", function (e) {
        sidebarClose()
    })


    // Close sidebar on body overlay click
    $(".nav__sidebar .menu-item a").on("click", function () {
        sidebarClose()
    })


    // Close sidebar on body overlay click on button menu
    $(".nav__sidebar .nav_m__container-button").on("click", function () {
        sidebarClose()
    })


    // Close sidebar on Escape key press
    $(document).keyup(function (e) {
        if (e.key === "Escape") {
            sidebarClose()
        }
    });

    // Toggle sidebar on hamburger click
    $(".nav__hamburger").on("click", function () {
        if($(this).hasClass('nav__hamburger--opened')){
            sidebarClose();
        } else {
            sidebarOpen();
        }
    })

})(jQuery);